<div
  [class]="borderClass()"
  class="flex h-full items-start gap-2 rounded-lg bg-white p-3 shadow-lg"
>
  <flx-notification-content
    [notification]="notification()"
    (actionClicked)="closed.emit()"
    class="flex-1"
  >
    <div
      class="text-sm/[22px] font-semibold text-neutral-900"
      data-testid="notification-title"
      notificationTitle
    >
      {{ notification().title }}
    </div>
  </flx-notification-content>

  <button
    (click)="closed.emit()"
    class="flx-ds small neutral -m-2"
    data-testid="notification-close-button"
    flxButton
    icon="center"
    variant="text"
    type="button"
  >
    <i
      class="ph ph-x"
      flxIcon
    ></i>
  </button>
</div>
